export default __webpack_public_path__ + "static/media/youtube.9dce52e4.svg";